<template>
  <div>
    <md-anchor v-for="(list, index) in dataList" :key="index">
      {{ `${index + 1}、${list}` }}</md-anchor
    >
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => {
        return [
          '通知人员只会接收到权限范围下学生的信息，权限为空则不发送通知。',
          '工作通知每人每日上限50条，超出限制后无法再接收到工作通知。'
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
